module.exports = __webpack_public_path__ + "media/images/icon_deadline_1-f27af8a8d0a206c2b71842604ff22d12.png";